import React, { useState, useEffect } from 'react'
import { Box, Grid, Link, TextField, MenuItem, BottomNavigationAction } from '@material-ui/core';
import { useStore } from '../../Store'
import Header from '../Header'
import ActionBar from '../ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import Photos from '../Photos';
import { getErrorProps, getOptions } from '../../utils';

const ObservationDetails = ({ readonly, formik, handleCancel, handleSubmit }) => {
    const { plots, settings } = useStore()

    const [taxa, setTaxa]= useState([])
    const [specie, setSpecie] = useState('')

    const description = `observation.description`
    const specieName = `observation.specieName`
    const taxLisTaxId = `observation.taxLisTaxId`
    const abundance = `observation.abundance`
    const methode = `observation.extraInfo.methode`
    const opm_waarneming = `observation.extraInfo.opm_waarneming`

    useEffect(() => {   
        if (!formik.values.observation?.taxLisTaxId) {
            formik.setFieldValue(taxLisTaxId, '', true)
        }
        console.log(formik.values.observation.taxLisTaxId)
    }, [])

    useEffect(() => {   
        if (formik.values.observation?.taxLisTaxId) {
            const taxaItem= taxa.find( item => item.id == formik.values.observation.taxLisTaxId)
            if (taxaItem) {
                setSpecie(taxaItem.name)
            }
        }
    }, [taxa])

    useEffect(() => {
        const plot = plots.find(p => p.id === formik.values.plot)
        const taxaList = settings.taxaLists.find(t => t.id === plot.taxaListId)
        setTaxa(taxaList.taxa.filter(t => t.type === 'row').sort((a, b) => a.sortorder > b.sortorder ? 1 : -1))
    }, [formik.values.plot])

    
    const changeSpecie = async (e) => {
        const item = taxa.find(t => t.name === e.target.value)
        setSpecie(item.name)
        await formik.setFieldValue(taxLisTaxId, item ? item.id : "",true)
        formik.setFieldValue(description, item ? `${item.name}, ${item.name2}` : "")
        formik.handleChange(e)
    }

    const changeTaxLisTaxId = (e) => {
        const item = taxa.find(t => t.id == e.target.value)
        const observation = formik.values.observations.find(o => o.taxLisTaxId === item.id)
        if (observation) {
            formik.setFieldValue('observation', JSON.parse(JSON.stringify(observation)))
            formik.setFieldValue(abundance, observation.abundance)
        } else {
            formik.setFieldValue(abundance, '');
        }
        formik.setFieldValue(taxLisTaxId, `${item.id}`, true)
        formik.setFieldValue(description, item ? `${item.name}, ${item.name2}` : "", true)
        formik.handleChange(e)
    }

    return (
        formik.values.observation &&
        <>
            <Header title={formik.values.observation.description || 'Nieuwe waarneming'} backAction={handleCancel} />
            <Box m={2}>
                <Grid container>
                    <Grid item xs={12}>
                        <TextField required select disabled={readonly} name={specieName} label="soort" variant="standard" fullWidth
                            value={specie}
                            onChange={changeSpecie}
                        >
                        { [...new Map(taxa.map(item => [item['name'], item])).values()].map(item => {
                            return (
                                <MenuItem key={item.name} value={item.name}>
                                    {item.name}
                                </MenuItem>
                            )})}
                        </TextField>
                    </Grid>
                    {typeof(formik.values.observation?.taxLisTaxId)!== 'undefined' && <Grid item xs={12}>
                        <TextField required select disabled={readonly} label="stadium/geslacht" variant="standard" name={taxLisTaxId} fullWidth
                            {...formik.getFieldProps(taxLisTaxId)}
                            onChange={changeTaxLisTaxId}
                            {...getErrorProps(formik, taxLisTaxId)}
                        >
                            {taxa.filter(item => item.name === specie).map(item => {
                                return (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name2}
                                    </MenuItem>
                                )
                            })}
                        </TextField>
                    </Grid>}
                    <Grid item xs={12}>
                        <TextField required disabled={readonly} label="aantal" variant="standard" name={abundance} type="number" fullWidth  {...getErrorProps(formik, abundance)} {...formik.getFieldProps(abundance)} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="zoek/vang methode" variant="standard" name={methode} fullWidth  {...getErrorProps(formik, methode)} {...formik.getFieldProps(methode)} >
                            {getOptions(settings.lists["methode"])}
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="opmerkingen" variant="standard" name={opm_waarneming} multiline fullWidth  {...getErrorProps(formik, opm_waarneming)} {...formik.getFieldProps(opm_waarneming)} />
                    </Grid>

                    <Grid item xs={12}>
                        <Photos
                            uploads={formik.values.observation.uploads}
                            setUploads={(uploads) => formik.setFieldValue('observation.uploads', uploads)}
                            readonly={readonly}
                            formik={formik}
                        />
                    </Grid>

                </Grid>
            </Box>
            {!readonly &&
                <ActionBar>
                    {!readonly && <BottomNavigationAction label="Waarneming opslaan" component={Link} to="/" onClick={handleSubmit} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
                </ActionBar>}
        </>
    )
}

export default ObservationDetails
